import React from 'react';
import Button from '../../../Components/Button';
import Input from '../../../Components/Input';
import Modal from '../../../Components/Modal';
import Select from '../../../Components/Select';
import { PageType } from '../../../Model/PageData';
import { emulatorVendStateOptions } from './useEmulator';

type Props = {
    open: boolean;
    onClose: () => void;
    qrValue: string;
    onQrValueChange: (value: string) => void;
    onSendQr: () => void;
    vendState: PageType;
    onVendStateChange: (value: PageType) => void;
};

function EmulatorConfigModal({
    open,
    onClose,
    qrValue,
    onQrValueChange,
    onSendQr,
    vendState,
    onVendStateChange,
}: Props) {
    return (
        <Modal open={open} close={onClose} className="max-w-lg">
            <p className="text-xl font-semibold primary">EMULATOR CONFIG</p>
            <p className="mt-1 text-sm text-gray-500">
                Set the vend result screen and dispatch QR scan values into the
                preview runtime.
            </p>
            <Select
                label="Vend Result Screen"
                value={vendState}
                onChange={(e) => onVendStateChange(e.target.value as PageType)}
                helperText="All vend actions in preview will end on this screen."
            >
                {emulatorVendStateOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </Select>
            <div className="mt-4 flex gap-4 items-center">
                <Input
                    label="QR Value"
                    value={qrValue}
                    onChange={(e) => onQrValueChange(e.target.value)}
                    placeholder="Enter a QR payload"
                    helperText="Use Send QR to trigger QR_SCAN_READY with this value."
                />
                <Button
                    className="bg-primary-light text-white"
                    onClick={() => {
                        onSendQr();
                        onClose();
                    }}
                >
                    Send QR
                </Button>
            </div>
        </Modal>
    );
}

export default EmulatorConfigModal;
